//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headerTips: {
      type: String,
      default: '',
    },
    mainTips: {
      type: String,
      default: '',
    },
  },
}
